import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { useContext } from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native"
import { PlaceColors } from "../helpers/PlaceColors";

export const FindifyLoadingScreen = (props: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    return <View style={[
        styles.container,
        styles.horizontal
    ]}>
        <ActivityIndicator size="large" color={PlaceColors(findifyDataContext).text.get()} />
    </View>

}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
    },
    horizontal: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: 10,
    },
});
